// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__E7NmZ","title":"Header_title__3XEh6","left":"Header_left__2nJQ0","clinicName":"Header_clinicName__1W765"};